const CSRF_COOKIE_NAME = "__Host-ua-csrf-token";
const CSRF_COOKIE_NAME_INSECURE = "ua-csrf-token";
const CSRF_HEADER_NAME = "X-CSRF-Token";

function getCookie(name) {
  if (typeof document === "undefined" || !(document.cookie)) {
    return "";
  }

  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(name + "=") === 0) {
      return decodeURIComponent(cookie.substring(name.length + 1));
    }
  }

  return "";
}

function normalizeMethod(input) {
  return (input || "GET").toString().toUpperCase();
}

function getCsrfToken() {
  return getCookie(CSRF_COOKIE_NAME) || getCookie(CSRF_COOKIE_NAME_INSECURE) || "";
}

function isUnsafeMethod(method) {
  return !(["GET", "HEAD", "OPTIONS"].includes(normalizeMethod(method)));
}

function isSameOriginUrl(url) {
  try {
    var resolved = new URL(url || window.location.href, window.location.href);
    return resolved.origin === window.location.origin;
  } catch (error) {
    return true;
  }
}

/**
 * Platform bootstrap: patches same-origin fetch() requests so script-driven
 * unsafe methods automatically carry the CSRF header. Native HTML form posts and
 * XMLHttpRequest are intentionally out of scope for this initial slice.
 */
function patchFetchForCsrf() {
  if (typeof window === "undefined" || typeof window.fetch !== "function") {
    return;
  }

  if (window.fetch.__uaCsrfPatched) {
    return;
  }

  var originalFetch = window.fetch.bind(window);

  var wrappedFetch = async function(input, init) {
    /*
     * NEVER synthesize `new Request(input, init)` here, and never copy headers
     * off such a Request.
     *
     * Two ways that corrupts the caller's request:
     *  1. MULTIPART CORRUPTION. When init.body is a FormData, the Request
     *     constructor encodes it and mints a Content-Type carrying a FRESH
     *     random multipart boundary. Copying that header into nextInit and then
     *     calling fetch() again with the SAME FormData makes the browser encode
     *     the body a SECOND time with a DIFFERENT boundary — while the explicit
     *     Content-Type header still names the first one. The server's multipart
     *     parser never finds its terminator and every upload fails with busboy's
     *     "Unexpected end of form".
     *  2. BODY REUSE. `new Request(existingRequest)` marks the source Request's
     *     body as used, so forwarding that same Request to fetch() can throw.
     *
     * Method and URL are read directly instead; isSameOriginUrl() already
     * resolves relative URLs against the document base.
     */
    var inputIsRequest = (typeof Request !== "undefined") && (input instanceof Request);

    var method = normalizeMethod((init || {}).method || (inputIsRequest ? input.method : "GET"));
    var url = inputIsRequest
      ? input.url
      : (typeof input === "string" ? input : ((input && input.url) || (input ? String(input) : window.location.href)));

    if (isUnsafeMethod(method) && isSameOriginUrl(url)) {
      var token = getCsrfToken();
      if (token) {
        // Mirror native fetch() header precedence: an init.headers value
        // replaces the Request's headers; otherwise the Request's own headers
        // apply. Content-Type is never authored here, so the browser keeps
        // generating the boundary that matches the body it actually sends.
        var headerSource = ((init || {}).headers) || (inputIsRequest ? input.headers : null);
        var headers = new Headers(headerSource || {});
        if (!(headers.has(CSRF_HEADER_NAME))) {
          headers.set(CSRF_HEADER_NAME, token);
          var nextInit = Object.assign({}, init || {});
          nextInit.headers = headers;
          return originalFetch(input, nextInit);
        }
        // The caller already supplied the token — pass the request through
        // untouched rather than rebuilding its headers.
      }
    }

    return originalFetch(input, init);
  };

  wrappedFetch.__uaCsrfPatched = true;
  wrappedFetch.__uaCsrfOriginal = originalFetch;
  window.fetch = wrappedFetch;
}

module.exports = {
  patchFetchForCsrf: patchFetchForCsrf,
  getCookie: getCookie,
  getCsrfToken: getCsrfToken,
  CSRF_COOKIE_NAME: CSRF_COOKIE_NAME,
  CSRF_COOKIE_NAME_INSECURE: CSRF_COOKIE_NAME_INSECURE,
  CSRF_HEADER_NAME: CSRF_HEADER_NAME
};
